import axios from 'axios';
import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

function EditPCA() {
  const { id } = useParams();

  const [form, setForm] = useState({
    requisitante: '',
    objeto: '',
    justificativa: '',
    expectativa_consumo_anual: '',
    valor_preliminar: '',
    data_pretendida: '',
    prioridade: '',
    indicacao_vinculacao_dependencia: '',
  });

  const navigate = useNavigate();

  const handleChange = (e) => {
    setForm((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  useEffect(() => {
    axios
      .get('/api/get/' + id)
      .then((res) => {
        console.log(res.data.Result[0]);
        setForm(res.data.Result[0]);
      })
      .catch((err) => console.log(err));
  }, [id]);

  const handleUpdate = async (e) => {
    e.preventDefault();
    console.log('handleUpdate disparado');
    try {
      await axios.put(`/api/editpca/${id}`, form);
      navigate('/listapca');
    } catch (err) {
      console.log(err);
    }
  };
  return (
    <div className="px-4 py-3">
      <h3 className="mb-4">Editar PCA</h3>
      <form onSubmit={handleUpdate}>
        <div className="mb-3">
          <label>Requisitante</label>
          <input
            type="text"
            name="requisitante"
            className="form-control"
            required
            value={form.requisitante}
            onChange={handleChange}
          />
        </div>

        <div className="mb-3">
          <label>Objeto</label>
          <input
            type="text"
            name="objeto"
            className="form-control"
            required
            value={form.objeto}
            onChange={handleChange}
          />
        </div>

        <div className="mb-3">
          <label>Justificativa</label>
          <textarea
            name="justificativa"
            className="form-control"
            required
            value={form.justificativa}
            onChange={handleChange}
          ></textarea>
        </div>

        <div className="mb-3">
          <label>Expectativa de Consumo Anual</label>
          <input
            type="number"
            name="expectativa_consumo_anual"
            className="form-control"
            required
            value={form.expectativa_consumo_anual}
            onChange={handleChange}
          />
        </div>

        <div className="mb-3">
          <label>Valor Preliminar da Contratação</label>
          <input
            type="number"
            step="0.01"
            name="valor_preliminar"
            className="form-control"
            required
            value={form.valor_preliminar}
            onChange={handleChange}
          />
        </div>

        <div className="mb-3">
          <label>Data Pretendida para Contratação</label>
          <input
            type="date"
            name="data_pretendida"
            className="form-control"
            required
            value={form.data_pretendida}
            onChange={handleChange}
          />
        </div>

        <div className="mb-3">
          <label>Prioridade da Compra ou Contratação</label>
          <input
            type="text"
            name="prioridade"
            className="form-control"
            required
            value={form.prioridade}
            onChange={handleChange}
          />
        </div>

        <div className="mb-3">
          <label>Indicação de Vinculação</label>
          <input
            type="text"
            name="indicacao_vinculacao_dependencia"
            className="form-control"
            value={form.indicacao_vinculacao_dependencia}
            onChange={handleChange}
          />
        </div>

        <button type="submit" className="btn btn-primary">
          Salvar PCA
        </button>
      </form>
    </div>
  );
}

export default EditPCA;
